import { Pagination, Table } from "antd";
import React, { useState, useRef, useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import Style from "./Style/Style";
import "./SrtTable.css";
import BeatLoader from "react-spinners/BeatLoader";
import { useEffect } from "react";
import { Loader } from "../../../UIComponents/Loader";
import {
  getSrtInitialList,
  massSearchFilter,
  selectUnselectSrtTableRows,
  srtEXportArray,
  srtSeasonSearchFilter
} from "../../../Redux/actions/Srt/Srt";
import { useLocation, useNavigate } from "react-router-dom";
import Description from "./Description/Description.js";
import AccordionContent from "../AccordionContent/AccordionContent.js";

const SrtTable = ({ brand, current, setCurrent, pageCount, setPageCount, chunkSize, containerRef, resetExpandRef }) => {
  const dispatch = useDispatch();
  const srtDataList = useSelector((state) => state?.Srt?.getSrtDataList);
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [accordionResetKey, setAccordionResetKey] = useState(0);
  const srtSeasonData = useSelector((state) => state?.Srt?.srtSeasonSearch);
  console.log("srtseasondasta", srtSeasonData);
  const handleExpand = (expanded, record) => {
    if (expanded) {
      setExpandedRowKeys([record.key]);
      dispatch(selectUnselectSrtTableRows([]));
      dispatch(srtEXportArray([]));
    } else {
      setExpandedRowKeys([]);
      dispatch(selectUnselectSrtTableRows([]));
      dispatch(srtEXportArray([]));
      localStorage.removeItem("srtSelectedExportKeys");
    }
  };

  const massFilterApiData = useSelector(
    (state) => state?.Srt?.massSearchFilterResult
  );
  const srtSearchLoader = useSelector((state) => state?.Srt?.searchLoader);
  const selectedUnselectedRows = useSelector(
    (state) => state?.Srt?.srtSelectedTableRows
  );
  const srtScrollPosition = localStorage.getItem("srtAutoScroll");

  const location = useLocation();
  const navigate = useNavigate();
  const [visibleCount, setVisibleCount] = useState(chunkSize);
  const [isChunkLoading, setIsChunkLoading] = useState(false);

  useEffect(() => {
    setVisibleCount(chunkSize);
    const scrollEl = containerRef?.containerRef?.containerRef?.current;
    if (scrollEl) {
      scrollEl.scrollTop = 0;
    }
  }, [current]);

  const updateQueryParams = (page, pageSize) => {
    const newQueryParams = new URLSearchParams(location.search);
    newQueryParams.set("page", page);
    newQueryParams.set("pageSize", pageSize);
    navigate({ search: newQueryParams.toString() }, { replace: true });
  };

  useEffect(() => {
    if (resetExpandRef) {
      resetExpandRef.current = () => {
        setAccordionResetKey(prev => prev + 1);
        setExpandedRowKeys([]);
      };
    }
  }, [resetExpandRef]);

  const activeDataSource = useMemo(() => {
    const freshLocalData = JSON.parse(localStorage.getItem("srtMassData"));
    const hasOnlySeasonFilter =
    freshLocalData?.seasonFilter?.length > 0 &&
    !freshLocalData.searchFilter &&
    !freshLocalData.colorFilter &&
    !freshLocalData.sizeFilter &&
    !freshLocalData.statusFilter &&
    !freshLocalData.vendorFilter;

    if (hasOnlySeasonFilter) {
      return srtSeasonData || { results: [], count: 0 };
    }
    const hasMassFilterConditions =
      freshLocalData &&
      (freshLocalData.searchFilter ||
        freshLocalData.brandfilter ||
        freshLocalData.colorFilter ||
        freshLocalData.sizeFilter ||
        freshLocalData.statusFilter ||
        freshLocalData.seasonFilter ||
        freshLocalData.vendorFilter);

    if (hasMassFilterConditions) {
      return massFilterApiData || { results: [], count: 0 };
    }
    return srtDataList || { results: [], count: 0 };
  }, [massFilterApiData, srtDataList,srtSeasonData]);

  const sourceData = useMemo(() => {
    return activeDataSource?.results || [];
  }, [activeDataSource]);

  // Group data by style for parent table
  const groupedData = useMemo(() => {
    return Object.values(
      sourceData?.reduce((acc, item) => {
        const key = item.style;
        if (!acc[key]) {
          acc[key] = {
            key,
            style_pid: item?.style_pid,
            style: item?.style,
            brand:item?.brand,
            description: item?.description,
            season: item?.season,
            vendorsMap: new Map(),
            colorMap: new Map(),
            sizeMap: new Map(),
            isNewColorKey: item?.is_new_colorkey,
            isNewStyleKey: item?.is_new_stylekey,
            isRedevelopmentVendor: item?.is_redevelopment_vendor
          };
        }

        const vendorKey = item?.factory;
        const colorKey = item?.color_code;
        const sizeKey = item?.size;

        if (vendorKey && !acc[key].vendorsMap.has(vendorKey)) {
          acc[key].vendorsMap.set(vendorKey, {
            name: item?.factory,
            status: item?.vendor_status || "Execute",
          });
        }

        if (colorKey && !acc[key].colorMap.has(colorKey)) {
          acc[key].colorMap.set(colorKey, colorKey);
        }
        if (sizeKey && !acc[key].sizeMap.has(sizeKey)) {
          acc[key].sizeMap.set(sizeKey, sizeKey);
        }
        return acc;
      }, {})
    ).map((item) => ({
      ...item,
      vendors: Array.from(item.vendorsMap.values()),
      colors: Array.from(item.colorMap.values()),
      sizes: Array.from(item.sizeMap.values()),
    }));
  }, [sourceData]);

  const tableData = useMemo(() => {
    return groupedData.map((item, index) => ({
      key: item.style || item.style_pid || index,
      style_pid: item.style_pid,
      ParentStyle: (
        <Style
          sockId={item.style}
          promisedExFactory={item}
          sockName={item?.description}
          vendor={item?.vendors}
          color={item?.colors}
          size={item?.sizes}
          brand={brand}
          season={item?.season}
        />
      ),
      StyleDescription: <Description sockName={item.description} />,
      Season: <p className="seasonDisplay">{item?.season}</p>,
      Vendors: (
        <div className="season-wrapper">
          <p className="season-title">Vendors</p>
          <p>{item.vendors.length}</p>
        </div>
      ),
      vendors: item.vendors,
      Codes: (
        <div className="season-wrapper">
          <p className="season-title">Colors</p>
          <p>{item.colors.join(", ")}</p>
        </div>
      ),
      Sizes: (
        <div className="season-wrapper">
          <p className="season-title">Sizes</p>
          <p>{item.sizes.join(", ")}</p>
        </div>
      ),
      AllData: item
    }));
  }, [groupedData, brand]);

  const columns = [
    { title: "", dataIndex: "Season" },
    { title: "", dataIndex: "ParentStyle" },
    { title: "", dataIndex: "StyleDescription", width: "30%" },
    { title: "", dataIndex: "Vendors", width: "15%" },
    { title: "", dataIndex: "Codes", width: "10%" },
    { title: "", dataIndex: "Sizes" },
    Table.EXPAND_COLUMN,
  ];

  const onSelectChange = (newSelectedRowKeys) => {
    const selectedKeySet = new Set(newSelectedRowKeys);
    const selectedSourceRows = sourceData.filter((item) =>
      selectedKeySet.has(item.style || item.style_pid)
    );

    const relatedStylePids = [
      ...new Set(
        selectedSourceRows.map((item) => item.style_pid).filter(Boolean)
      ),
    ];

    const relatedSamplePids = [
      ...new Set(
        selectedSourceRows.map((item) => item.sample_pid).filter(Boolean)
      ),
    ];

    dispatch(srtEXportArray(relatedStylePids));
    const existingKeys = JSON.parse(localStorage.getItem("srtSelectedExportKeys") || "[]");
    const mergedKeys = [...new Set([...existingKeys, ...relatedStylePids])];

    localStorage.setItem("srtSelectedExportKeys", JSON.stringify(mergedKeys));
    dispatch(selectUnselectSrtTableRows(newSelectedRowKeys));

    const newlyCheckedKey = newSelectedRowKeys.find(
      (key) => !selectedUnselectedRows.includes(key)
    );

    if (newlyCheckedKey) {
      setExpandedRowKeys([newlyCheckedKey]);
    }
  };

  useEffect(() => {
    localStorage.removeItem("srtSelectedExportKeys");
  }, [srtDataList, massFilterApiData]);

  const rowSelection = {
    selectedRowKeys: selectedUnselectedRows,
    onChange: onSelectChange,
  };

  const handleRowClick = (record, rowIndex) => { };

  useEffect(() => {
    if (expandedRowKeys.length === 0) return;
    if (srtSearchLoader && tableData.length === 0) return;

    const availableKeys = tableData.map((item) => item.key);
    const preservedKeys = expandedRowKeys.filter((key) =>
      availableKeys.includes(key)
    );

    if (preservedKeys.length !== expandedRowKeys.length) {
      setExpandedRowKeys(preservedKeys);
    }
  }, [tableData, expandedRowKeys, srtSearchLoader]);

  useEffect(() => {
    if (!containerRef?.containerRef?.containerRef?.current) return;

    const scrollEl = containerRef?.containerRef?.containerRef?.current;
    const handleScroll = () => {
      const { scrollTop, clientHeight, scrollHeight } = scrollEl;
      const bottomReached = scrollTop + clientHeight >= scrollHeight - 15;

      if (bottomReached && visibleCount < tableData.length) {
        setIsChunkLoading(true);
        setTimeout(() => {
          setVisibleCount(prev => Math.min(prev + chunkSize, tableData.length));
          setIsChunkLoading(false);
        }, 400);
      }
    };

    scrollEl.addEventListener("scroll", handleScroll);
    return () => scrollEl.removeEventListener("scroll", handleScroll);
  }, [visibleCount, tableData.length, chunkSize, containerRef]);

  const handleScrollButton = () => {
    if (srtScrollPosition) {
      window.scrollTo({
        top: containerRef?.current?.offsetTop,
      });
      containerRef?.current?.scrollTo({
        top: srtScrollPosition,
      });
    }
  };

  useEffect(() => {
    handleScrollButton();
  }, [srtDataList, massFilterApiData]);

  const getTotalCount = () => activeDataSource?.count || 0;
  const isChangingPageSizeRef = useRef(false);

  const onShowSizeChange = (current, pageSize) => {
    isChangingPageSizeRef.current = true;
    setCurrent(1);
    setPageCount(pageSize);
    updateQueryParams(1, pageSize);
    handlePaginationChange(1, pageSize);
    setTimeout(() => {
      isChangingPageSizeRef.current = false;
    }, 0);
  };

  const onChange = (page) => {
    if (isChangingPageSizeRef.current) {
      return;
    }
    setCurrent(page);
    updateQueryParams(page, pageCount);
    handlePaginationChange(page, pageCount);
  };

 const handlePaginationChange = useCallback(
  (current, pageCount) => {
      const freshLocalData = JSON.parse(localStorage.getItem("srtMassData"));
      const localData = JSON.parse(localStorage.getItem("massFilterData"));
      const freshSrtDataForApi = JSON.parse(localStorage.getItem("srtData") || "{}");

      const hasOnlySeasonFilter =
        freshLocalData?.seasonFilter?.length > 0 &&
        !freshLocalData.searchFilter &&
        !freshLocalData.colorFilter &&
        !freshLocalData.sizeFilter &&
        !freshLocalData.statusFilter &&
        !freshLocalData.vendorFilter;

      if (hasOnlySeasonFilter) {
        dispatch(
          srtSeasonSearchFilter(
            freshLocalData?.brandfilter || brand,
            freshLocalData?.seasonFilter,
            current,
            pageCount,
            0
          )
        );
      } else if (
        freshLocalData &&
        (freshLocalData.searchFilter ||
          freshLocalData.colorFilter ||
          freshLocalData.sizeFilter ||
          freshLocalData.statusFilter ||
          freshLocalData.vendorFilter)
      ) {
        dispatch(
          massSearchFilter(
            freshLocalData?.searchFilter || "",
            freshLocalData?.brandfilter || "",
            freshLocalData?.colorFilter || "",
            freshLocalData?.sizeFilter || "",
            freshLocalData?.statusFilter || "",
            freshLocalData?.vendorFilter || "",
            0,
            freshLocalData?.seasonFilter || "",
            current,
            pageCount
          )
        );
      } else if (freshSrtDataForApi?.brand || freshSrtDataForApi?.style) {
        dispatch(
          getSrtInitialList(
            freshSrtDataForApi?.brand || brand,
            freshSrtDataForApi?.style || "",
            freshSrtDataForApi?.factory || "",
            "",
            0,
            freshSrtDataForApi?.season || "",
            current,
            pageCount
          )
        );
      } else {
        dispatch(
          getSrtInitialList(
            localData?.brand || brand,
            "",
            "",
            "",
            0,
            "",
            current,
            pageCount
          )
        );
      }
    },
    [dispatch, brand]
  );

  return (
    <>
      {srtSearchLoader && <Loader />}
      <div className="srt-table">
        <Table
          expandRowByClick
          onMouseEnter={false}
          rowSelection={rowSelection}
          columns={columns}
          dataSource={tableData.slice(0, visibleCount)}
          pagination={false}
          rowClassName={() => "row"}
          onRow={(record, rowIndex) => {
            return {
              onClick: (event) => {
                handleRowClick(record, rowIndex);
              },
            };
          }}
          expandable={{
            expandedRowKeys: expandedRowKeys,
            onExpand: handleExpand,
            expandedRowRender: (record) => (
              <AccordionContent
                key={`${record.key}-${accordionResetKey}`}
                vendor={record?.vendors}
                itemData={record?.AllData}
                promisedExFactory={record?.is_new_colorkey}
                selectedRow={expandedRowKeys}
                parentSelected={selectedUnselectedRows.includes(record.key)}
                intialSearchData={sourceData}
              />
            ),
            rowExpandable: (record) => record.name !== "Not Expandable",
          }}
        />
        {isChunkLoading && (
          <BeatLoader
            color={"#0C3D5E"}
            loading={isChunkLoading}
            cssOverride={{
              margin: "30px auto",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              borderColor: "#0C3D5E",
            }}
            size={10}
            aria-label="Loading Spinner"
            data-testid="loader"
          />
        )}
      </div>

      <Pagination
        current={current}
        onChange={onChange}
        total={getTotalCount()}
        pageSize={pageCount}
        showSizeChanger={false}
        style={{ textAlign: "right", marginTop: "20px" }}
      />
    </>
  );
};

export default SrtTable;
